import { BaseComponent } from '../../../../components/BaseComponent';
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { HBox, VBox } from '../../../../components/Box';
import { Modal, ModalControls } from '../../../../components/Modal';
import { Button } from '../../../../components/Buttons';
import { IsOpen, Times } from '../../../../components/Icon';
import { Cell, List, Row } from '../../../../components/List';
import { Loader } from '../../../../components/Loader';
import { MainModal } from './MainModal';
import { EditTransportOrderBulkActionModal } from './EditTransportOrderBulkActionModal';

import { removeAllTransportOrdersFromBulkActionsList, removeTransportOrderFromBulkActionsList } from '../../actions';
import { selectWork } from '../../../Api/selectors';
import { LAYOUT_BREAK_SMALL } from '../../../../containers/App/constants';
import { REQUEST_ADD_DOCUMENT } from '../../../Users/constants';
import { COLOR_PRIMARY_1 } from '../../../../vars';
import { PrintCMRModal } from '../../../Vehicles/pages/BulkActions/PrintCMRModal';
import { ExportInExcelModalBase } from '../../../Vehicles/pages/BulkActions/ExportInExcelModalBase';

const Container = styled.div`
  position: fixed;
  display: flex;
  z-index: 9999;

  right: 2%;
  bottom: 0;
  justify-content: center;
  align-items: center;
  overflow: auto;

  .header {
    background-color: ${COLOR_PRIMARY_1};
    color: white;
    width: auto;
    height: 60px;
    margin: -12px 0 0 0;
    padding: 0px 24px;
    .button {
      margin: 0;
      text-align: right;
      width: 40px;
    }
  }

  .times {
    display: flex;
    padding: 0 8px;
  }

  .button {
    width: 200px;
  }

  @media (max-width: 768px) {
    position: fixed;
    bottom: 0;
    right: 0;
    overflow: auto;
    width: 100%;
    .header {
      background-color: ${COLOR_PRIMARY_1};
      color: white;
      width: 100%;
      margin: 0;
      padding: 6px 24px;
      .button {
        margin: 0;
        text-align: right;
        width: 40px;
      }
    }

    .modal-footer-button {
      margin: 0;
      display: flex;
      height: 70px;
      min-width: 50%;

      .list-result-label {
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: 500;
        width: 45px;
        height: 45px;
        border-radius: 50%;
        margin: 5px;
        background-color: #fff;
        color: ${COLOR_PRIMARY_1};
      }
    }
  }
`;

const Inner = styled.div`
  background-color: rgba(255, 255, 255, 1);
  border-radius: 6px;
  padding: 12px 0 0 0;
  min-width: 380px;
  width: ${props => (props?.wider ? '60%' : props?.mediumWide ? '40%' : 'auto')};
  visibility: ${props => (props.isShowMainModal ? 'hidden' : '')};
  max-width: 100%;
  max-height: 90%;
  overflow: auto;

  @media (max-width: ${LAYOUT_BREAK_SMALL}px) {
    min-width: 300px;
    width: 100%;
    height: ${props => (props.isOpen ? '100vh' : '')};
    padding-top: 0;

    .footer-controls {
      position: fixed;
      bottom: 0;
    }
  }

  .model-info {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    max-width: 330px;
  }

  .bulk-action-list {
    padding: 12px;
    overflow: auto;
    max-height: 200px;
    font-size: 14px;

    @media (max-width: 768px) {
      min-height: 80vh;
      max-height: auto;
      overflow: none;
    }
  }

  .icon-block {
    display: flex;
    align-items: center;
    justify-contect: center;
    cursor: pointer;
    width: 25px;
    height: 25px;
    background-color: #d50046;
    color: #fff;
  }
`;

const TopControls = styled.div`
  text-align: right;
`;

const Title = styled.div`
  font-weight: 600;
`;

const STATE = {
  isOpen: false,
  loading: false,
  isShowMainModal: false,
};

// IMPORTANT TO ADD NEW MODALS HERE WITH FALSE VALUE
const INITIAL_MODALS_STATE = {
  isShowEditModal: false,
  isShowMainModal: false,
  isShowPrintCMRModal: false,
  isShowExcelModal: false,
};

class BulkActionsTransportOrderCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  reset() {
    this.setState({
      ...INITIAL_MODALS_STATE,
    });
  }

  get transportOrders() {
    return this.props.bulkActionsList;
  }

  get vehicles() {
    return this.props.bulkActionsList?.filter(t => t?.vehicle?.id)?.map(transportOrder => transportOrder.vehicle);
  }

  get vehicleIds() {
    return this.props.bulkActionsList?.filter(t => t?.vehicle?.id)?.map(transportOrder => transportOrder.vehicle?.id);
  }

  get outgoingToAddressIds() {
    return this.vehicles?.map(vehicle => vehicle?.transport_outgoing_to_address_id);
  }

  get outgoingToCompanyId() {
    return this.vehicles[0]?.transport_outgoing_to_company_id;
  }

  getAction(action) {
    switch (action) {
      case 'showEditModal':
        return this.setState({
          ...INITIAL_MODALS_STATE,
          isShowEditModal: true,
        });
      case 'showPrintCMRModal':
        return this.setState({
          ...INITIAL_MODALS_STATE,
          isShowPrintCMRModal: true,
        });
      case 'showExcelModal':
        return this.setState({
          ...INITIAL_MODALS_STATE,
          isShowExcelModal: true,
        });
      case 'close':
        return this.setState({
          ...INITIAL_MODALS_STATE,
        });
    }
  }

  renderWarningModal() {
    if (!this.state.isShowWarningModal) return null;
    return (
      <Modal
        onClose={() => this.setState({ isShowWarningModal: false })}
        title={this.lbl('company.modal.delete.confirm.title')}
      >
        <ModalControls>
          <Button isPrimary onClick={() => this.props.removeAllTransportOrdersFromBulkActionsList(res => {})}>
            {this.lbl('confirm')}
          </Button>
          <Button onClick={() => this.setState({ isShowWarningModal: false })}>{this.lbl('cancel')}</Button>
        </ModalControls>
      </Modal>
    );
  }

  render() {
    return (
      <Container onClick={this.props.onClose} className="modal-container">
        {this.renderWarningModal()}
        {this.state.isShowMainModal && <MainModal sendAction={action => this.getAction(action)} />}
        {this.state.isShowEditModal && (
          <EditTransportOrderBulkActionModal
            mobileView={window.innerWidth <= 768}
            reset={this.reset.bind(this)}
            transportOrders={this.transportOrders}
            transportOrderVehicles={this.vehicles}
          />
        )}
        {this.state.isShowPrintCMRModal && (
          <PrintCMRModal
            reset={this.reset.bind(this)}
            transportOrderBulk
            vehicles={this.vehicles}
            vehicleIds={this.vehicleIds}
            outgoingToAddressIds={this.outgoingToAddressIds}
            outgoingToCompanyId={this.outgoingToCompanyId}
            sendAction={action => this.getAction(action)}
            paginatedList={this.props.currentPage}
          />
        )}
        {this.state.isShowExcelModal && (
          <ExportInExcelModalBase
            mobileView={window.innerWidth <= 768}
            reset={this.reset.bind(this)}
            vehicleIds={this.vehicleIds}
          />
        )}
        {this.props.work ? (
          <Loader small />
        ) : (
          <Inner
            isShowMainModal={this.state.isShowMainModal}
            isOpen={this.state.isOpen}
            onClick={evt => evt.stopPropagation()}
            className="modal-inner"
            mediumWide={this.props.mediumWide}
            wider={this.props.wider}
          >
            <HBox className="header" vCenter>
              <Title>{this.lbl('transport.overview.excel_card.title')}&nbsp;</Title>
              <TopControls>
                <div onClick={() => this.setState({ isOpen: !this.state.isOpen })}>
                  <IsOpen />
                </div>
              </TopControls>
            </HBox>
            {this.state.isOpen && (
              <div className="bulk-action-list">
                <List>
                  {this.props.bulkActionsList.map(transportOrder => (
                    <Row key={`${transportOrder?.vehicle?.brand_name}_${transportOrder?.id}`}>
                      <Cell>
                        <VBox>
                          <strong>
                            {transportOrder?.vehicleManual
                              ? transportOrder?.vehicleManual
                              : transportOrder?.vehicle?.brand_name + ' ' + transportOrder?.vehicle?.model_name}
                          </strong>
                        </VBox>
                      </Cell>
                      <Cell>
                        <div style={{ textAlign: 'left' }}>
                          <span style={{ textDecoration: 'none' }}>
                            <strong>{this.lbl('transport_order.filter.' + transportOrder.type)}</strong>{' '}
                          </span>
                          <br />
                        </div>
                      </Cell>
                      <Cell>
                        <div
                          className="icon-block"
                          onClick={() => this.props.removeTransportOrderFromBulkActionsList(transportOrder?.id)}
                        >
                          <Times />
                        </div>
                      </Cell>
                    </Row>
                  ))}
                </List>
              </div>
            )}
            {this.state.isOpen && (
              <HBox className="footer-controls">
                {this.state.loading && <Loader small />}
                <Button
                  className="modal-footer-button"
                  warning
                  onClick={() => {
                    this.setState({ isShowWarningModal: true });
                  }}
                >
                  {this.lbl('vehicle.overview.excel_card.delete_all')}
                </Button>
                <Button className="modal-footer-button" onClick={() => this.setState({ isShowMainModal: true })}>
                  {this.lbl('vehicle.overview.bulk_actions')}
                  {window.innerWidth <= 768 && <p className="list-result-label">{this.props.bulkActionsList?.length}</p>}
                </Button>
              </HBox>
            )}
          </Inner>
        )}
      </Container>
    );
  }
}

BulkActionsTransportOrderCardComp.propTypes = {};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWork(REQUEST_ADD_DOCUMENT),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    removeTransportOrderFromBulkActionsList(transportOrderId) {
      dispatch(removeTransportOrderFromBulkActionsList(transportOrderId));
    },
    removeAllTransportOrdersFromBulkActionsList(callback) {
      dispatch(removeAllTransportOrdersFromBulkActionsList(callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const BulkActionsTransportOrderCard = compose(withConnect, withRouter, injectIntl)(BulkActionsTransportOrderCardComp);
